// extracted by mini-css-extract-plugin
module.exports = {"button":"playTextButton_button__2dnk9","audio":"playTextButton_audio__3dKJN"};